import { CellContext } from "@tanstack/react-table";
import { Badge } from "@bcc/components/ui/badge";
import { VariantWithProductData } from "../types";
import { setTermCellTestId } from "../products-table.utils";
import { useTranslation } from "react-i18next";

export const TermCellMarkup = (props: CellContext<VariantWithProductData, unknown>) => {
  const { t } = useTranslation();
  const data = props.row.original;
  const isLongTerm = data.term === "Long";

  return (
    <div data-testid={setTermCellTestId(props.row.index)}>
      <Badge
        variant="outline"
        className={isLongTerm ? "border-primary/30 text-primary" : "border-amber-500/30 text-amber-600 dark:text-amber-400"}
      >
        {isLongTerm ? t("views.productsTable.term.longTerm") : t("views.productsTable.term.shortTerm")}
      </Badge>
    </div>
  );
};
